import logoImage from '../../assets/images/LOGO_NIRVA.svg';
import { useState, useRef, useLayoutEffect } from 'react';
import { Drawer, List, ListItem, ListItemText, Divider, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/system';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { openSimplePracticeConsultation } from '../../utils/simplePractice';
import { Box } from '@mui/material';
import SocialRow from '../SocialRow';

import {
  NavLinks,
  Navbar,
  StyledButtonWrapper,
  StyledLink,
  HeaderPlaceholder,
  HeaderContent,
  HeaderToolbar,
  NavLinkText,
  LogoContainer,
  Logo,
  CTAButton,
  BurgerButton,
  DrawerContent,
  DrawerLogoContainer,
  DrawerLogo,
  DrawerNavItem,
  DrawerNavText,
  DrawerButtonContainer,
  UICTAButton,
} from './styles';
import { NAV_ITEMS } from './constants';
import { useScrollHeader } from './hooks/useScrollHeader';
// import UICTAButton from '../../ui/ctaButton';
import { Gapper } from '../../ui/utils';

const Header = () => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(100);
  const headerRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const { isAtTop, isVisible } = useScrollHeader();

  const isActive = (path) => location.pathname === path;

  useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, [isMdDown]);

  const toggleDrawer = (val) => () => setOpen(val);

  const handleLogoClick = () => {
    navigate('/');
    if (isMdDown && open) setOpen(false);
  };

  const handleCTAClick = () => {
    openSimplePracticeConsultation();
    if (isMdDown && open) setOpen(false);
  };

  return (
    <>
      <HeaderPlaceholder sx={{ height: headerHeight }} />

      <Navbar ref={headerRef} isVisible={isVisible} isAtTop={isAtTop}>
        <HeaderContent>
          <HeaderToolbar>
            <Gapper flexDirection="row" gap={30}>
              <LogoContainer>
                <Logo src={logoImage} alt="Logo" onClick={handleLogoClick} isMobile={isMdDown} />
              </LogoContainer>

              <NavLinks>
                {NAV_ITEMS.map((item) =>
                  item.external ? (
                    <StyledLink
                      as="a"
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={item.label}
                    >
                      <NavLinkText variant="body1" data-text={item.label}>
                        {item.label}
                      </NavLinkText>
                    </StyledLink>
                  ) : (
                    <StyledLink to={item.to} key={item.label}>
                      <NavLinkText
                        variant="body1"
                        isActive={isActive(item.to)}
                        data-text={item.label}
                      >
                        {item.label}
                      </NavLinkText>
                    </StyledLink>
                  )
                )}
                <StyledButtonWrapper>
                  <CTAButton
                    variant="contained"
                    onClick={handleCTAClick}
                    text="Request a Free 30-Minute Consultation"
                  />
                  {/* {CONSULTATION_COPY.start}
                </CTAButton> */}
                </StyledButtonWrapper>
              </NavLinks>
            </Gapper>

            {isMdDown && (
              <BurgerButton
                aria-label="open navigation menu"
                onClick={toggleDrawer(true)}
                edge="end"
                size="large"
              >
                <MenuIcon />
              </BurgerButton>
            )}
          </HeaderToolbar>
        </HeaderContent>
        <Drawer
          anchor="right"
          open={open}
          onClose={toggleDrawer(false)}
          disableScrollLock={true}
          PaperProps={{ role: 'navigation' }}
        >
          <DrawerContent
            role="presentation"
            onKeyDown={(e) => {
              if (e.key === 'Escape') setOpen(false);
            }}
          >
            <DrawerLogoContainer>
              <DrawerLogo src={logoImage} alt="Logo" onClick={handleLogoClick} />
            </DrawerLogoContainer>

            <Divider sx={{ mb: 1 }} />

            <List>
              {NAV_ITEMS.map((item) => (
                <ListItem key={item.label} disablePadding>
                  <DrawerNavItem
                    {...(item.external
                      ? { component: 'a', href: item.href, target: '_blank', rel: 'noopener noreferrer' }
                      : { component: Link, to: item.to, selected: isActive(item.to) })}
                    onClick={toggleDrawer(false)}
                  >
                    <ListItemText
                      primary={item.label}
                      slotProps={{
                        primary: {
                          sx: {
                            ...DrawerNavText,
                            fontWeight: !item.external && isActive(item.to) ? 700 : 500,
                          },
                        },
                      }}
                    />
                  </DrawerNavItem>
                </ListItem>
              ))}
            </List>

            <Divider sx={{ my: 2 }} />

            <DrawerButtonContainer>
              <UICTAButton
                variant="contained"
                text="Request a Free 30-Minute Consultation"
                isMobile
                onClick={handleCTAClick}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
                <SocialRow />
              </Box>
            </DrawerButtonContainer>
          </DrawerContent>
        </Drawer>
      </Navbar>
    </>
  );
};

export default Header;
